module.exports = __webpack_public_path__ + "static/partner6-79f78fe94b1188bdf927277f8fed4068.png";